import { useState, useEffect, useCallback } from "react";
import { api } from "./api";

export function useAsync(fn, deps = []) {
  const [state, setState] = useState({
    data: null,
    loading: true,
    error: null,
  });
  const run = useCallback(async () => {
    setState((p) => ({ ...p, loading: true, error: null }));
    try {
      const data = await fn();
      setState({ data, loading: false, error: null });
    } catch (e) {
      setState((p) => ({ ...p, loading: false, error: e.message }));
    }
  }, deps);
  useEffect(() => {
    run();
  }, [run]);
  return { ...state, refetch: run };
}

export function usePaginated(path, pageSize = 50) {
  const [page, setPageNum] = useState(1);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

const fetch_ = useCallback(
  async (p) => {
    setLoading(true);
    setError(null);

    try {
      // ── This is the improved part ────────────────────────────────
      const separator = path.includes('?') ? '&' : '?';
      const fullUrl = `${path}${separator}page=${p}&limit=${pageSize}`;
      // ──────────────────────────────────────────────────────────────

      console.log("→ Sending request to:", fullUrl);

      const res = await api.get(fullUrl);

      setData(res.data ?? []);
      setTotal(res.total ?? 0);
      setTotalPages(res.totalPages ?? 1);
      setPageNum(p);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  },
  [path, pageSize],
);


  useEffect(() => {
    fetch_(1);
  }, [fetch_]);

  return {
    data,
    total,
    page,
    totalPages,
    loading,
    error,
    setPage: fetch_,
    refetch: () => fetch_(page),
  };
}


export function usePaginatedtrips(path, params = {}, pageSize = 50) {
  const [page, setPageNum] = useState(1);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Serialize params to a stable string so useCallback/useEffect
  // can detect when filters actually change
  const paramStr = JSON.stringify(params);

  const fetch_ = useCallback(
    async (p) => {
      setLoading(true);
      setError(null);
      try {
        // Build query string: page + limit + any extra filter params
        const parsed = JSON.parse(paramStr);
        const qs = new URLSearchParams({
          page: p,
          limit: pageSize,
          ...parsed, // e.g. { status: "confirmed", tripType: "family" }
        }).toString();

        const separator = path.includes("?") ? "&" : "?";
        const fullUrl = `${path}${separator}${qs}`;

        console.log("→ Sending request to:", fullUrl);

        const res = await api.get(fullUrl);

        console.log("data",res.data)
        setData(res.data ?? []);
        setTotal(res.total ?? 0);
        setTotalPages(res.totalPages ?? 1);
        setPageNum(p);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    },
    [path, pageSize, paramStr], // ← paramStr triggers refetch when filters change
  );

  useEffect(() => {
    fetch_(1); // reset to page 1 whenever path or filters change
  }, [fetch_]);

  return {
    data,
    total,
    page,
    totalPages,
    loading,
    error,
    setPage: fetch_,
    refetch: () => fetch_(page),
  };
}